import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import apiInstance from '../../utils/axios';

import './Categories.css';

const CategorySkeleton = () => (
  <div className="category-skeleton">
    {[...Array(12)].map((_, i) => (
      <div key={i} className="skeleton-card">
        <div className="skeleton-image" />
        <div className="skeleton-text" />
      </div>
    ))}
  </div>
);

const Categories = ({ onCategorySelect }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();


  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await apiInstance.get('category/');
        const categoriesData = Array.isArray(response.data) ? response.data : (response.data.results || []);
        setCategories(categoriesData);
        setLoading(false);
      } catch (error) {
        setError('No se pudieron cargar las categorías. Por favor, intentá de nuevo más tarde.');
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleCategoryClick = (categoryId) => {
    navigate(`/products?category=${categoryId}`);
  };

  return (
    <div className="categories-container">
      <div className="categories-header">
        <h2 className="categories-title">
          Categorías
        </h2>
        <div>
          <Link
            to="/categories"
            className="categories-link"
          >
            Ver todas las categorías
            <ChevronRight size={14} />
          </Link>
        </div>
      </div>

      {loading ? (
        <CategorySkeleton />
      ) : error ? (
        <div className="categories-error">
          <div className="categories-error-icon">😞</div>
          {error}
        </div>
      ) : (
        <div className="categories-grid">
          {Array.isArray(categories) && categories.map((category) => (
            <div
              key={category.id}
              className="category-card"
              onClick={() => handleCategoryClick(category.id)}
            >
              <img
                src={category.image || 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-cTLQOnESX7pZAEseH5Z3LGUPhcsuWd.png'}
                alt={category.title}
                className="category-image"
              />
              <div className="category-content">
                <h3 className="category-name">
                  {category.title}
                </h3>
                <p className="category-description">
                  Explorá la selección
                </p>
                <span className="category-count">
                  Ver productos
                </span>
              </div>
              <div className="category-arrow">
                <ChevronRight size={16} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Categories;